/** Extract a booking / proposal slug from known customer-app routes. */
export const bookingSlugFromPathname = (pathname: string): string | undefined => {
  const patterns = [
    /^\/b\/payment\/([^/]+)/,
    /^\/b\/([^/]+)/, // /b/:slug and nested
    /^\/p\/([^/]+)/, // booking proposal /p/:slug
    /^\/confirmation\/([^/]+)/,
    /^\/change\/([^/]+)/,
    /^\/feedback-for-booking\/([^/]+)/
  ];

  for (const pattern of patterns) {
    const match = pathname.match(pattern);
    if (match?.[1]) {
      return match[1];
    }
  }

  return undefined;
};
